<template>
  <div class="_order_">
    <div class="my_order">
      我的订单
    </div>
    <div class="order_status clearfix_">
      <ul class="clearfix_ fl">
        <li class="fl clearfix_"  v-for="(item,index) in orderStatusList" :key="index" @click="getOrderByState(item.id)">
          <span :class="{order_status_active:idx_==item.id}" class="fl">{{item.title}}</span><i class="fl">|</i>
        </li>
      </ul>
       <div class="order_search fr">
        <input v-model="goodsName" placeholder="商品名称或订单号或商户" type="text"><span @click="searchOrder(1)">搜索订单</span>
      </div> 
    </div>
    <div class="order_state_item">
      <div class="order_state_item_tit clearfix_">
        <p  class="name">商品</p>
        <p class="price">单价</p>
        <p class="num">数量</p>
        <p style="color:#f5f5f5;" class="goodsOperation">商品操作</p>
        <p class="collectGoods">收货人</p>
        <p class="payMoney">支付总金额</p>
        <p class="state">订单状态</p>
        <p class="operation">操作</p>
      </div>
      <div class="order_state_item_goods clearfix_" v-for="(item,index) in orderList" :key="index">
        <div class="order_state_item_goods_h2 clearfix_">
          <p class="fl">订单号：<router-link class="order_state_item_scode" tag="a" target="_blank" :to="{name:'orderDetails',query:{id:item.id}}">{{item.scode}}</router-link></p>
          <p class="fl">下单时间：<span>{{item.retailTime}}</span></p>
          <p class="fl">商户：<span>{{item.tenant}}</span></p>
        </div>
        <div class="clearfix_">
          <div class="fl" style="width:531px;">
            <div v-for="(val,idx) in item.items" :key="idx" class="order_state_item_goods_content clearfix_">
              <img @click="toGoods(val.dom,val.goodsId,val.supplyChainTenantId)" class="fl" :src="val.pic?val.pic:timg" alt="">
              <p @click="toGoods(val.dom,val.goodsId,val.supplyChainTenantId)" class="fl describe">{{val.goodsName}}<br>{{val.goodsUnitName}} {{val.property1}}</p>
              <p class="fl price">¥{{val.salesMoney}}</p>
              <p class="fl num">{{val.num}}</p>
              <p class="fl goodsOperation"></p>
            </div>
          </div>
          <div class="fl clearfix_" :style="{height:item.items.length*120+'px'}">
            <p class="fl collectGoods clearfix_">
              <span style="margin-top:15px;" class="fl">{{item.recipient}}</span>
            </p>
            <p class="fl payMoney clearfix_">
              <span style="margin-top:15px;" class="fl">¥{{item.totalAmount}}</span>
               <span v-show="item.postageMoney!='0.00'" class="fl">含运费：¥{{item.postageMoney}}</span>
            </p>
            <p style="" class="fl state clearfix_">
              <span style="margin-top:15px;" v-show="item.status==1" class="fl">待支付</span>
              <span style="margin-top:15px;" v-show="item.status==2" class="fl">待发货</span>
              <span style="margin-top:15px;" v-show="item.status==3" class="fl">待收货</span>
              <span style="margin-top:15px;" v-show="item.status==4" class="fl">待评价</span>
              <span style="margin-top:15px;" v-show="item.status==5" class="fl">追加评价</span>
              <span style="margin-top:15px;" v-show="item.status==-1" class="fl">已取消</span>
              <span style="cursor:pointer;margin-top:15px;" class="fl">
                <router-link class="see_detail_hover" tag="a" target="_blank" :to="{name:'orderDetails',query:{id:item.id}}">查看详情</router-link>
              </span>
            </p>
            <div class="fl" v-show="item.orderModel!=1">
              <p v-show="item.status==1" class="operation clearfix_">
                <span style="margin-top:15px;" class="fl"><button><router-link tag="a" target="_blank" :to="{name:'stayPay',query:{id:item.outTradeNo,orderId:item.id}}">立即支付</router-link></button></span>
                <span style="margin-top:15px;" class="fl"><button @click="updateOrderStatus('取消',item.id)">取消订单</button></span>
              </p>
              <p v-show="item.status>2" class="operation clearfix_">
                <span style="margin-top:15px;" class="fl"><router-link tag="a" target="_blank" :to="{name:'orderDetails',query:{id:item.id}}">查看物流</router-link></span>
              </p>
              <p v-show="item.status==3" class="operation clearfix_">
                <span style="margin-top:15px;" class="fl"><button @click="updateOrderStatus('确认收货',item.id,item.sendStatus)">确认收货</button></span>
              </p>
              <p v-show="(item.status==4&&item.goodsNum>item.returnNum)||(item.status==5&&item.goodsNum>item.returnNum)" class="operation clearfix_">
                <span v-show="item.envattionStatus==4&&item.goodsNum>item.returnNum" style="margin-top:15px;" class="fl"><button @click="goToEvaluate('评价',item.id)">评价</button></span>
                <span v-show="item.envattionStatus==5&&item.goodsNum>item.returnNum" style="margin-top:15px;" class="fl"><button @click="goToEvaluate('追加评价',item.id)">追加评价</button></span>
              </p>
              <p v-show="item.status==-1" class="operation clearfix_">
                <span style="margin-top:15px;" class="fl"><button @click="updateOrderStatus('删除',item.id)">删除订单</button></span>
              </p>
              <p v-show="item.returnNum>0" class="operation clearfix_">
                <span style="margin-top:15px;" class="fl"><button><router-link tag="a" target="_blank" :to="{name:'viewReturns',query:{orderId:item.id}}">查看退货</router-link></button></span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-show="noData" class="noTime">暂无该状态订单！</div>
      <div v-show="total" class="order_page">
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="this.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/reset.css'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  inject:['reload'],
  data(){
    return {
      orderStatusList:[{title:'全部订单',id:0},{title:'待付款',id:1},{title:'待发货',id:2},{title:'待收货',id:3},{title:'待评价',id:4},{title:'已取消',id:-1},{title:'已删除',id:-2}],
      idx_:0,
      orderList:[],
      currentPage3:1,
      total:null,
      timg:require('../../assets/img/timg.gif'),
      noData:false,
      goodsName:''
    }
  },
  mounted:function(){
    var t_=this
    t_.idx_=t_.$route.query.state
    if(t_.idx_==8)t_.idx_=3
    t_.getOrderList(t_.idx_,1)
  },
  methods:{
    updateOrderStatus:function(name,id,sendStatus){
      var t_=this
      var message=''
      if(name=='取消')message='确定要取消该订单吗？'
      if(name=='删除')message='确定要删除该订单吗？'
      if(name=='确认收货'){
        if(sendStatus==2){
          message='部分商品未发货，是否确认收货？'
        }else if(sendStatus==3){
          message='确定要收货吗？'
        }
      }
      t_.$confirm(message,'提示',{
        confirmButtonText:'确认',
        cancelButtonText:'取消',
        // distinguishCancelAndClose:true,
        type:'warning'
      }).then(()=>{
        var data0bj={
          tamp:localStorage.tamp?localStorage.tamp:'',
          channel:2,
          ids:id
        }
        if(name=='取消')data0bj.status=-1
        if(name=='删除')data0bj.status=-2
        if(name=='确认收货')data0bj.status=4
        data0bj=Qs.stringify(data0bj)
        axios.post(`${ip}formWorkInterface/updateOrderStatus`,data0bj).then(res=>{
          if(overtime(res.data.code)){
            localStorage.removeItem('tamp')
            localStorage.removeItem('name')
            return this.$router.push({
              path: '/LoginHome?state=1',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
            });
            this.$router.go(0);
          }
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if(res.data.code==0){
            t_.$message({
              message:res.data.message,
              center:true,
              type:'success'
            })
            t_.reload()
            // var n
            // if(name=='取消')n=5
            // if(name=='删除')n=6
            // if(name=='彻底删除')n=0
            // if(name=='确认收货')n=4
            // t_.$router.push({
            //   name: 'order',
            //   query: {state: n}
            // })
          }else{
            t_.$message({
              message:res.data.message,
              center:true,
              type:'warning'
            })
          }
        })
      }).catch(action=>{
        
      });
    },
    goToEvaluate:function(name,id){
      var t_=this
      var isAppend
      if(name=='评价'){
        isAppend=''
      }
      if(name=='追加评价'){
        isAppend=1
      }
      t_.$router.push({
        name: 'evaluateOrder',
        query: {id: id,isAppend:isAppend}
      })
    },
    toGoods:function(web,id,supplyChainTenantId){
      var t_=this
      var url='http://'+web+'/goodsdetails?goodsId='+id+'&supplyChainTenantId='+supplyChainTenantId+'&isSupplyChainGoods=2'
      window.open(url,'_blank')
    },
    handleSizeChange(val){

    },
    handleCurrentChange(val) {
      this.currentPage3=val
      this.orderList=[]
      this.getOrderList(this.idx_,val)
    },
    searchOrder:function(val){
      var t_=this
      t_.noData=false
      t_.idx_=0
      var data0bj={
        page:val,
        pagesize:10,
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        goodsName:t_.goodsName,
        status:0
      }
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/listRetailOrders`,data0bj).then(res =>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.data.rows.length==0)t_.noData=true
          t_.orderList=res.data.data.rows
          t_.total=res.data.data.total
        }
      })
    },
    getOrderByState:function(idx){
      console.log( idx )
      var t_=this
      t_.orderList=[]
      t_.currentPage3=1
      t_.idx_=idx
      let query = this.$router.history.current.query;
      let path = this.$router.history.current.path;
      //对象的拷贝
      let newQuery = JSON.parse(JSON.stringify(query));
      newQuery.state = t_.idx_;
      this.$router.push({ path, query: newQuery });
      t_.noData=false
      t_.getOrderList(t_.idx_,t_.currentPage3)
    },
    getOrderList:function(idx,val){
      var t_=this
      t_.idx_=idx
      var data0bj={
        page:val,
        pagesize:10,
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:''
      }
      data0bj.status=idx
      if(t_.goodsName)data0bj.goodsName=t_.goodsName
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/listRetailOrders`,data0bj).then(res =>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.data.rows.length==0)t_.noData=true
          t_.orderList=res.data.data.rows
          t_.total=res.data.data.total
        }
      })
    },
  }
}
</script>
<style>
  ._order_{
    background:#fff;
    padding: 25px 20px 0 20px;
    border: 1px solid #ddd;
  }
  .my_order{
    height: 34px;
    background: #eee;
    margin-bottom: 40px;
    border: 1px solid #e0e0e0;
    border-left: 5px solid #dd2a3c;
    font-weight: 900;
    line-height: 34px;
    font-size:16px;
    text-indent: 15px;
    color:#333;
  }
  .order_status{
    margin-bottom: 20px;
    border-bottom: 1px solid #cecece;
  }
  .order_status ul{
    height: 25px;
    width: 610px;
  }
  .order_status li span{
    padding: 0 19px;
    height: 25px;
    text-align: center;
    cursor: pointer;
  }
  .order_status li i{
    color:#ccc;
  }
  .order_status li{
    font-size:14px;
  }
  .order_status li:last-child i{
    display: none;
  }
  .order_status .order_status_active{
    color:#dd2a3c;
     border-bottom: 4px solid #dd2a3c;; 
    position: relative;
    z-index: 100;
    height: 22px;
  }
  .order_status li:last-child{
    border-right:0;
  }
  .order_status .order_search{
    /* border: 1px solid #e5e5e5; */
    margin-top: -6px;
    position: relative;
    height: 26px;
  }
  .order_status .order_search input{
    border:1px solid #ccc;
    width: 240px;
    height: 26px;
    padding-left: 5px;
  }
  .order_status .order_search span{
    width: 69px;
    height: 26px;
    position: absolute;
    background: #f5f5f5;
    top: 1px;
    right: 1px;
    text-align: center;
    line-height: 26px;
    cursor: pointer;
  }
  .order_state_item_tit{
    height: 30px;
    background: #f5f5f5;
    margin-bottom: 20px;
    /* padding-left: 308px; */
  }
  .order_state_item_tit .name{
    width: 308px;
    text-align: center;
  }
  .order_state_item_tit p{
    float: left;
    line-height: 30px;
  }
  .order_state_item_tit .price{
    width: 85px;
    text-align: center;
  }
  .order_state_item_tit .num{
    width: 55px;
    text-align: center;
  }
  .order_state_item_tit .goodsOperation{
    width: 86px;
    text-align: center;
  }
  .order_state_item_tit .collectGoods{
    width: 110px;
    text-align: center;
  }
  .order_state_item_tit .payMoney{
    width: 110px;
    text-align: center;
  }
  .order_state_item_tit .state{
    width: 110px;
    text-align: center;
  }
  .order_state_item_tit .operation{
    width: 120px;
    text-align: center;
  }
  .order_state_item_goods{
    border: 1px solid #e5e5e5;
    margin-bottom: 20px;
  }
  .order_state_item_goods_h2{
    background:#f5f5f5;
    border-bottom:1px solid #e5e5e5;
    height: 39px;
  }
  .order_state_item_goods_h2 p{
    line-height: 39px;
    color:#b4b4b4;
    padding-left: 20px;
  }
  .order_state_item_goods_h2 p span{
    color:#333;
  }
  .order_state_item_goods_content{
    padding-left: 10px;
    min-height: 120px;
    float: left;
  }
  .order_state_item_goods_content img{
    width: 80px;
    height: 80px;
    margin-right: 15px;
    margin-top: 15px;
    cursor: pointer;
  }
  .order_state_item_goods_content .describe{
    width: 180px;
    line-height: 20px;
    margin-right: 20px;
    margin-top: 15px;
    height: 100%;
    cursor: pointer;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
  }
  .order_state_item_goods_content .describe:hover{
    color:#dd2a3c;
  }
  .order_state_item_goods_content .price{
    width: 85px;
    text-align: center;
    margin-top: 15px;
    height: 100%;
  }
  .order_state_item_goods_content .num{
    width: 55px;
    text-align: center;
    margin-top: 15px;
    height: 100%;
  }
  .order_state_item_goods_content .goodsOperation{
    width: 85px;
    text-align: center;
    border-right: 1px solid #e5e5e5;
    min-height: 110px;
    padding-top: 10px;
  }
  .order_state_item_goods .collectGoods{
    width: 109px;
    text-align: center;
    border-right: 1px solid #e5e5e5;
    height: 100%;
  }
  .order_state_item_goods .collectGoods span{
    width: 100%;
    text-align: center;
  }
  .order_state_item_goods .payMoney{
    width: 109px;
    text-align: center;
    border-right: 1px solid #e5e5e5;
    height: 100%;
  }
  .order_state_item_goods .payMoney span{
    width: 100%;
    margin-bottom: 12px;
  }
  .order_state_item_goods .state{
    width: 109px;
    text-align: center;
    border-right: 1px solid #e5e5e5;
    height: 100%;
  }
  .order_state_item_goods .state span{
    width: 100%;
    /* margin-bottom: 12px; */
  }
  .order_state_item_goods .operation{
    text-align: center;
    height: 100%;
    width: 125px;
  }
  .order_state_item_goods .operation span{
    width: 100%;
    /* margin-bottom: 12px; */
     cursor: pointer;
  }
  .order_state_item_goods .operation span button{
     width:  72px;
     height: 24px;
     color:#fff;
     text-align: center;
     line-height: 24px;
     background: #dd2a3c;
     border: 0;
     border-radius: 2px;
     font-size: 12px;
     cursor: pointer;
  }
  .order_page{
    margin-bottom: 20px;
    text-align: center;
  }
  .order_page .el-pagination__jump{
    margin-top:-9px;
  }
  .order_page .el-pagination__jump .el-pagination__editor{
    top: 9px;
  }
  .noTime{
    text-align: center;
    margin-bottom: 20px;
  }
  .see_detail_hover:hover{
    color: #dd2a3c;
  }
  .order_state_item_scode{
    cursor: pointer;
    color: #333;
  }
  .order_state_item_scode:hover{
    color: #dd2a3c;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/order.vue